<template>
  <div class="position-relative" v-window-click="hideOptions" v-resize="calculateOptionsWidth">
    <div class="box hvh-flex align-center space-between no-wrap clickable" :class="{ opened: showOptions, selected: selectedText }" @click="openOptions">
      <span class="overflow-hidden hvh-flex grow-1">
        <span class="truncate">{{ selectedText || title }}</span>
        <span class="ml-1" v-if="plusText">{{ plusText }}</span>
      </span>
      <div :class="{ 'no-show w-0': selectedText }" @click.stop>
        <v-icon @click="openOptions" v-if="!showOptions">mdi-menu-down</v-icon>
        <v-icon @click="showOptions = false" v-else>mdi-menu-up</v-icon>
      </div>
      <v-icon class="ml-2 mr-1" color="#666adf" small @click.stop="$emit('clear')" v-if="selectedText">mdi-close</v-icon>
    </div>
    <template v-if="showOptions">
      <div class="options" :style="optionsPositionStyle" @click.stop.prevent v-if="showOptions" ref="options">
        <slot />
      </div>
    </template>
  </div>
</template>

<script>
import { getAllParentNodes } from '../../../../libraries/common';
export default {
  props: ['title', 'options', 'selectedText', 'plusText'],
  data() {
    return {
      optionsWidth: 0,
      clientTop: 0,
      clientLeft: 0,
      clientBottom: 0,
      optionsHeight: 0,
      scrollTop: 0,
      showOptions: false,
      parentNodes: [],
    };
  },
  computed: {
    optionsPositionStyle() {
      var shouldGoUp = this.parentNodes.last().offsetHeight < this.clientBottom + this.optionsHeight;
      return {
        left: `${this.clientLeft}px`,
        top: shouldGoUp ? `${this.clientTop - this.optionsHeight - this.scrollTop}px` : `${this.clientBottom - this.scrollTop}px`,
        minWidth: `${this.optionsWidth}px`
      };
    },
    optionsWidthTrigger() {
      return [this.showOptions, ...(this.options || [])];
    },
  },
  methods: {
    calculateOptionsWidth() {
      this.$nextTick(() => {
        if (this.$refs.options) {
          var optionsWidth = [this.optionsWidth, this.$refs.options.offsetWidth, this.$el.offsetWidth, 200].max();
          if (this.optionsWidth !== optionsWidth) {
            this.optionsWidth = optionsWidth;
          }
          var optionsHeight = this.$refs.options.offsetHeight;
          if (this.optionsHeight !== optionsHeight) {
            this.optionsHeight = optionsHeight;
          }

          var boundingBox = this.$el.getBoundingClientRect();
          var clientTop = boundingBox.top;
          if (this.clientTop !== clientTop) {
            this.clientTop = clientTop;
          }
          var clientLeft = boundingBox.left;
          if (this.clientLeft !== clientLeft) {
            this.clientLeft = clientLeft;
          }
          var clientBottom = boundingBox.bottom;
          if (this.clientBottom !== clientBottom) {
            this.clientBottom = clientBottom;
          }
        }
      });
    },
    openOptions() {
      setTimeout(() => this.showOptions = true, 50);
    },
    hideOptions() {
      this.showOptions = false;
    },
    onScroll() {
      var stopTime = Date.now() + 300;
      var onAnimation = () => {
        if (Date.now() < stopTime) {
          this.calculateOptionsWidth();
          requestAnimationFrame(onAnimation);
        }
      }
      requestAnimationFrame(onAnimation);
    },
  },
  watch: {
    showOptions() {
      if (!this.showOptions)
        this.optionsWidth = 0;
    },
    optionsWidthTrigger() {
      this.calculateOptionsWidth();
    },
  },
  updated() {
    this.calculateOptionsWidth();
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCohortFilterLayout'] = this;

    var pars = getAllParentNodes(this.$el);
    var fixedParent = pars
      .find(f => window.getComputedStyle(f).position === 'fixed');

    this.parentNodes = pars.filter((_, ind) => !fixedParent || ind <= pars.indexOf(fixedParent));
    this.parentNodes.forEach(el => el.addEventListener('mousewheel', this.onScroll));

    this.calculateOptionsWidth();
  },
  beforeDestroy() {
    this.parentNodes.forEach(el => el.addEventListener('mousewheel', this.onScroll));
  },
}
</script>

<style lang="scss" scoped>
.box {
  position: relative;
  padding: 6px 4px 6px 16px;
  border-radius: 4px;
  border-color: #b0b3b6;
  background-color: #ffffff;

  &:not(.opened) {
    box-shadow: 0 1px 2px 1px rgba(6, 10, 36, 0.1);
  }

  &.opened {
    background-color: white;
    box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
  }

  &.selected {
    color: #666adf;
    border: 0.5px solid #666adf;
    background-color: #ebecff;
    box-shadow: 0 1px 2px 1px rgba(6, 10, 36, 0.1);
  }
}
.options {
  position: fixed;
  background-color: white;
  padding: 20px 16px 4px;
  // min-width: 100%;
  box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
  z-index: 1;
}

.fit-screen {
  max-width: 400px;
  overflow: hidden;
}
</style>